import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import useBrand from '@hooks/useBrand'
import useUsers from '@hooks/useUsers'

import type { UserModel } from '@models/types'

import BrandTemplateDeveloperListItem from './BrandTemplateDeveloperListItem'

interface BrandTemplateDevelopersProps {
  brandId: number,
}

const BrandTemplateDevelopers = (props: BrandTemplateDevelopersProps) => {
  const { brandId } = props

  const brandPayload = useBrand({ id: brandId })
  const {
    brand,
    callbacks: { manageBrandTemplateDevelopers },
    hasTemplateDevelopers,
    loading,
    templateDeveloperUserIds,
  } = brandPayload

  const usersPayload = useUsers({
    // @ts-expect-error TS2741
    filters: { user_ids: templateDeveloperUserIds },
    performHttpRequests: hasTemplateDevelopers,
  })

  const { filteredUsers } = usersPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Template Developers"
    >
      {!loading && !hasTemplateDevelopers && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Template Developers Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please assign a Template Developer.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && hasTemplateDevelopers && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection flexDirection="column">
          {filteredUsers.map((user: UserModel) => (
            <BrandTemplateDeveloperListItem
              key={user.id}
              brand={brand}
              user={user}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => manageBrandTemplateDevelopers()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Template Developer
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default BrandTemplateDevelopers
